import { render, staticRenderFns } from "./UpdateRequired.vue?vue&type=template&id=453f3d13&scoped=true"
import script from "./UpdateRequired.vue?vue&type=script&lang=js"
export * from "./UpdateRequired.vue?vue&type=script&lang=js"
import style0 from "./UpdateRequired.vue?vue&type=style&index=0&id=453f3d13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453f3d13",
  null
  
)

export default component.exports